import React from "react";

const RulesOfWork = ( {data} ) => {
    return(
        <div className="flex flex-col lg:gap-8 md:gap-6 gap-4 leading-tight">
            {
                data.rulesofwork.map((rulesofwork, index) =>(
                    <>
                        <span className="font-medium md:text-[40px] text-[32px]" style={{color: rulesofwork.title_color}}>
                            {rulesofwork.title}
                        </span>
                        <div className="grid md:grid-cols-3 grid-cols-1 gap-3">
                            {
                                rulesofwork.card.map((card,index) => (
                                    <div className="flex flex-col p-6 lg:gap-20 md:gap-14 gap-6 h-fit rounded-[20px] shadow-2xl" 
                                            style={{backgroundColor: card.bg}}
                                        >
                                        <div className="flex justify-between gap-6 font-meduim lg:text-[24px] md:text-[18px] text-[18px]">
                                            <span className="flex text-balance" style={{color: card.text_color}}>{card.text}</span>
                                            <span className="flex border-solid border-2 rounded-full lg:w-16 lg:h-16 md:w-12 md:h-12 w-12 
                                                    h-12 p-5 items-center justify-center" 
                                                    style={{color: card.index_color, borderColor:card.border_color}}
                                                >
                                                {card.index}
                                            </span>
                                        </div>
                                        <div className="flex flex-col gap-3 font-medium lg:text-[16px] md:text-[14px] text-[14px]">
                                            {
                                                card.list.map((list, index) =>(
                                                    <div className="flex gap-2">        
                                                        <span className="" style={{color: list.index_color}}>{list.index}</span>
                                                        <span className="" style={{color: list.text_color}}>{list.text}</span>
                                                    </div>
                                                ))
                                            }
                                            
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </>
                ))
            }
        </div>
    );
};
export default RulesOfWork;